import type { LangCode } from './locales-config';

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getStorage } from 'minimal-shared/utils';
import LanguageDetector from 'i18next-browser-languagedetector';

import { i18nOptions, fallbackLng, storageConfig, i18nResourceLoader } from './locales-config';

// ----------------------------------------------------------------------

const i18nextLng = getStorage(
  storageConfig.localStorage.key,
  storageConfig.localStorage.autoDetection ? undefined : fallbackLng
) as LangCode;

/**
 * Initialize i18next
 */
i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(i18nResourceLoader)
  .init({
    ...i18nOptions(i18nextLng),
    detection: { caches: ['localStorage'] },
  });

export default i18next;
